var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"account"},[_c('viewPage',_vm._b({on:{"save":_vm.save}},'viewPage',{requests: _vm.requests},false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }